module.exports = "/_next/static/resources/hero-1-fc52030fc6400331f794c6c97e18a2b1.jpg";